// Author YuJiaBei
// Date 2020-07-23 17:20:18

class EmActProcessVariable {
constructor({
        id = null,
        processRegisterId = '',
        processRegisterName = '',
        name = '',
        key = '',
        value = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.processRegisterId = processRegisterId;
    this.processRegisterName = processRegisterName;
    this.name = name;
    this.key = key;
    this.value = value;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new EmActProcessVariable();
}

function gridFields() {
return Object.freeze([
        {
        key: 'processRegisterId',
        label: 'label.em.base.workflow.emActProcessVariable.grid.processRegisterId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'processRegisterDefinitionKey',
        label: 'label.em.base.workflow.emActProcessVariable.grid.processRegisterDefinitionKey',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'processRegisterName',
        label: 'label.em.base.workflow.emActProcessVariable.grid.processRegisterName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.base.workflow.emActProcessVariable.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'key',
        label: 'label.em.base.workflow.emActProcessVariable.grid.key',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'value',
        label: 'label.em.base.workflow.emActProcessVariable.grid.value',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.em.base.workflow.emActProcessVariable.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '启用' },
                            { value: '2', text: '冻结' },
                            { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.workflow.emActProcessVariable.grid.remark',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    processRegisterIdFilter : "",
    processRegisterNameFilter : "",
    nameFilter : "",
    keyFilter : "",
    valueFilter : "",
    statusFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'processRegisterNameFilter',
        label: 'label.em.base.workflow.emActProcessVariable.filter.processRegisterName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"processRegisterId":"id"}'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.base.workflow.emActProcessVariable.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'keyFilter',
        label: 'label.em.base.workflow.emActProcessVariable.filter.key',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'valueFilter',
        label: 'label.em.base.workflow.emActProcessVariable.filter.value',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.base.workflow.emActProcessVariable.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' },
                { value: '3', text: '删除' }
            ]
        }
        }
];

const entityFormConfigs = [
        {
        key: 'processRegisterName',
        label: 'label.em.base.workflow.emActProcessVariable.entity.processRegisterName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"processRegisterId":"id"}'
                }
        },
        {
        key: 'name',
        label: 'label.em.base.workflow.emActProcessVariable.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'key',
        label: 'label.em.base.workflow.emActProcessVariable.entity.key',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'value',
        label: 'label.em.base.workflow.emActProcessVariable.entity.value',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'status',
        label: 'label.em.base.workflow.emActProcessVariable.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' },
                { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.workflow.emActProcessVariable.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmActProcessVariable, newEntity, gridFields, fields, filterFields, filter, filterConfigs, entityFormConfigs}
